import IdentityModal from './IdentityModal'

export default IdentityModal
